import {
  Avatar,
  Box,
  Collapse,
  Grid,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CardTitleWithSubtitle from "../../components/CardTitleWithSubtitle/CardTitleWithSubtitle";
import CustomCard from "../../components/CustomCard/CustomCard";
import Layout from "../../components/Layout/Layout";
import QueryPageTitleCard from "../../components/QueryPageTitleCard/QueryPageTitleCard";
import { routesConfig } from "../../config/routes";
import { useOrderQuote } from "../../contexts/orderQuote/OrderQuoteContext";
import { getFormattedTimestamp } from "../../utils/dateFormatter";

import { useAuth } from "../../contexts/authentication/AuthenticationContext";
import { Roles } from "../../components/SideBar/Content/ListItem";
import { TypesPermissions } from "../../components/Routes/TypesPermissions";
import { AuthenticationContextData } from "../../contexts/authentication/domain";
import CustomButton, {
  CustomButtonVariant,
} from "../../components/CustomButton/CustomButton";
import FilterTableIcmsSection from "./Sections/FilterTableIcmsSection";
import TaxReimbursementTableSection from "./Sections/TaxReimbursementTableSection";
import { GetRefundIcmsQuery } from "../../modules/financial/models/GetRefundIcmsQuery";

const TaxReimbursement: React.FC = () => {
  const navigate = useNavigate();
  const { setDataItemInView, setItemInView } = useOrderQuote();
  const [query, setQuery] = useState<GetRefundIcmsQuery | null>({});
  const [filtersExpanded, setFiltersExpanded] = useState(true);
  const { authByPermission, permissionSet, roles } =
    useAuth() as AuthenticationContextData;

  const handleSearch = (e: any): any => {
    setQuery(e);
  };

  useEffect(() => {
    setDataItemInView?.({});
    setItemInView?.("");
  }, [setDataItemInView]);

  const permissionIs = authByPermission(
    permissionSet.SYSTEM_MODULES,
    roles.has(Roles.ADMIN),
    TypesPermissions.TAX_REIMBURSEMENT_REQUEST
  );

  return (
    <Layout
      enableMargin
      appBarProps={{
        notification: {
          onChange() {},
        },
        chat: {
          onChange() {},
        },
        settings: {
          onChange() {},
        },
        avatar: () => (
          <Avatar
            alt="Avatar"
            src="/images/avatar.png"
            sx={{
              width: 60,
              height: 60,
            }}
          />
        ),
      }}
    >
      <Box
        sx={{
          height: "130vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box sx={{ flexShrink: 0, mb: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <QueryPageTitleCard
                title="Ressarcimento de ICMS fiscal"
                componentItem={
                  <CustomButton
                    title="Solicitar novo ressarcimento"
                    onClick={() =>
                      navigate(
                        routesConfig.FINANCIAL().TAX_REIMBURSEMENT_REQUEST
                      )
                    }
                    variant={
                      permissionIs
                        ? CustomButtonVariant.CONTAINED
                        : CustomButtonVariant.DISABLED
                    }
                    disabled={!permissionIs}
                  />
                }
              />
            </Grid>

            <Grid item xs={12}>
              <CustomCard
                sx={{ boxShadow: "none", border: "1px solid #DFE0EB", p: 2 }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <CardTitleWithSubtitle
                    title="Solicitações de ressarcimento de ICMS fiscal"
                    subtitle={getFormattedTimestamp(new Date())}
                  />
                  <Tooltip
                    title={
                      filtersExpanded ? "Recolher Filtros" : "Expandir Filtros"
                    }
                  >
                    <IconButton
                      onClick={() => setFiltersExpanded(!filtersExpanded)}
                      sx={{ ml: 2 }}
                    >
                      {filtersExpanded ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                </Stack>

                <Collapse in={filtersExpanded} timeout="auto">
                  <Box sx={{ pt: 2 }}>
                    <FilterTableIcmsSection
                      dataFilter={(e) => handleSearch(e)}
                    />
                  </Box>
                </Collapse>
              </CustomCard>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CustomCard
            sx={{
              boxShadow: "none",
              height: "100%",
              p: 0.5,
            }}
          >
            <TaxReimbursementTableSection dataFilter={query} key={1} />
          </CustomCard>
        </Box>
      </Box>
    </Layout>
  );
};

export default TaxReimbursement;
